import { render, staticRenderFns } from "./admission.payment.vue?vue&type=template&id=a5a03bb2"
import script from "./admission.payment.vue?vue&type=script&lang=js"
export * from "./admission.payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports